import React from 'react';

import { connect } from 'react-redux';
import BaseComponent from '../../baseClasses/BaseComponent';
import PopupMenu from '../../components/PopupMenu';
import dataModel from '../../models/DataModel';
import MultipleUsersIcon from '../../components/Iconoclast/MultipleUsersIcon';
import './UserAvatar.scss';

export class UserAvatar extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { menu: null, isValidImage: false, isUnmounted: false };
  }

  componentDidMount() {
    super.componentDidMount();
    this.validateProfileImage();
  }

  componentDidUpdate() {
    this.validateProfileImage();
  }

  /**
   * Confirm the profile image actually decodes before rendering an <img> for it, so a broken URL
   * falls back to initials instead of a broken image.
   *
   * Each distinct URL is checked at most once, and state is only written when the result changes.
   * Both guards matter: previously a URL that failed to decode looped forever, because setState
   * re-triggered componentDidUpdate, which still saw isValidImage === false and checked again.
   * The await makes every pass a separate tick, so React's update-depth guard never fired, and
   * each pass queued another image decode -- enough to wedge the renderer once the tab is visible
   * (background tabs defer decoding, which is why it only died in the foreground).
   */
  async validateProfileImage() {
    const image = this.props.user ? this.props.user.profile_image : null;

    if (!image) {
      this.checkedImage = null;
      if (this.state.isValidImage) {
        this.setState({ isValidImage: false });
      }
      return;
    }

    if (image === this.checkedImage) {
      return;
    }
    this.checkedImage = image;

    const isValid = await this.checkValidImage(image);
    if (!this.state.isUnmounted && isValid !== this.state.isValidImage) {
      this.setState({ isValidImage: isValid });
    }
  }

  componentWillUnmount(){
    this.state.isUnmounted = true;
  }

  handleMenuSelection(type) {
    if (this.props.handleMenuSelection) {
      this.props.handleMenuSelection(type, this.props.user);
    }  
  }

  handleCloseMenu() {
    this.setState({ menu: null });
  }

  handleMouseDown() {
    if (this.props.menuOptions) {
      if (!this.state.menu) {
        const menu = <PopupMenu left={0} top={35} width={200} menuOptions={this.props.menuOptions} size="smaller"
          menuId={'user-menu-' + this.props.user.id} popupOnHover={false} handleMenuSelection={this.handleMenuSelection}
          handleClickAway={this.handleCloseMenu} />;
        this.setState({ menu: menu });
      }
    }
  }

  async checkValidImage(url) {
    try {
      const img = new Image();
      img.src = url;
      await img.decode();
      return true;
    } catch (error) {
      return false;
    }
  }

  handleClick(e) {
    e.stopPropagation();
    if (this.props.handleSelected) {
      this.props.handleSelected(this.props.user, e);
    }
  }

  render() {
    let { user, selected, selectedBlue, large, larger, extraLarge, largest, small, multiAssigned, disabledWithOpacity } = this.props;
    let disableClass = '';
    if(!this.props.handleSelected){
      disableClass = ' disabled';
    }
    if (disabledWithOpacity) {
      disableClass = ' disabled with-opacity';
    }
    let profileImage = user ? (user.prefetchedImage && dataModel.isOffline ? user.prefetchedImage : user.profile_image) : null;

    let userImage = null;
    const selectedClass = selected ? ' selected' : selectedBlue ? ' selected blue' : '';
    if (profileImage && this.state.isValidImage) {
      userImage = <div id={this.props.id} className={'user-avatar' + selectedClass + (larger ? ' larger' : '') + (large ? ' large' : small ? ' small' : '') + (extraLarge ? ' extra-large' : '') + (largest ? ' largest' : '') + disableClass} onMouseDown={this.handleMouseDown} onClick={this.handleClick}>
        {this.state.menu}
        <div className="user-image-container">
          <img className="profile-image" alt="User" src={profileImage} data-id={user.id} />
        </div>
      </div>;
    }
    else if (multiAssigned) {
      userImage = <div id={this.props.id} className={'user-avatar' + selectedClass + (larger ? ' larger' : '') + (large ? ' large' : small ? ' small' : '') + (extraLarge ? ' extra-large' : '') + (largest ? ' largest' : '') + disableClass} onMouseDown={this.handleMouseDown} onClick={this.handleClick}>
        {this.state.menu}
        <div className="user-image-container" data-id={'multiple-users-icon'}>
          <MultipleUsersIcon />
        </div>
      </div>;
    }
    else if (user && user.multiSelect && user.all) {
      userImage = <div id={this.props.id} className={'user-avatar' + selectedClass + (larger ? ' larger' : '') + (large ? ' large' : small ? ' small' : '') + (extraLarge ? ' extra-large' : '') + (largest ? ' largest' : '') + disableClass} onMouseDown={this.handleMouseDown}
        onClick={this.handleClick}>
        {this.state.menu}
          <div className="user-image-container" data-id={'multiple-users-icon'}>
            <MultipleUsersIcon />
          </div>
      </div>;
    }
    else if (user) {
      const initials = (user.first_name ? user.first_name.substr(0, 1).toUpperCase() : '') + (user.last_name ? user.last_name.substr(0, 1).toUpperCase() : '');
      userImage = <div id={this.props.id} className={'user-avatar' + selectedClass + (larger ? ' larger' : '') + (large ? ' large' : small ? ' small' : '') + (extraLarge ? ' extra-large' : '') + (largest ? ' largest' : '') + disableClass} onMouseDown={this.handleMouseDown}
          onClick={this.handleClick}>
          {this.state.menu}
          <div className="default-user-image-container" data-id={user.id}>
            <div className="default-user-image" data-id={user.id} />
            <div className="user-initials" data-id={user.id}>{initials}</div>
          </div>
        </div>;
    }
    else {
      const initials = 'NA';
      if (!this.user_id) {
        this.user_id = Math.floor(Math.random() & 9999);
      }
      userImage = <div id={this.props.id} className={'user-avatar' + selectedClass + (larger ? ' larger' : '') + (large ? ' large' : small ? ' small' : '') + (extraLarge ? ' extra-large' : '') + (largest ? ' largest' : '') + disableClass} onMouseDown={this.handleMouseDown} onClick={this.handleClick}>
          {this.state.menu}
          <div className="default-user-image-container" data-id={this.user_id}>
          <div className="default-user-image" data-id={this.user_id} />
            <div className="user-initials" data-id={this.user_id}>
              {initials}
            </div>
          </div>
        </div>;  
    }
    return userImage;
  }
}

// Change to appropriate class name

const mapStateToProps = (state, ownProps) => {
  return {
    permissions: state.new_users.permissions,
  };
};

export default connect(mapStateToProps)(UserAvatar);



// WEBPACK FOOTER //
// ./src/components/UserAvatar/index.js